import React, { FunctionComponent, ReactNode, useContext } from 'react'
import classNames from 'classnames/bind'

import { DropDownColorPresetContext } from '../DropdownContainer'

import styles from './DropdownItem.module.scss'
import { Icon, IconsType } from '../../Icon'
import { TestProps } from '../../../../misc/types.utilities'

const classNamesCx = classNames.bind(styles)

interface DropdownItemProps extends TestProps {
  children?: ReactNode
  onClick?: (evt: React.MouseEvent) => void
  title?: string
  href?: string
  target?: '_blank' | '_self'
  icon?: IconsType
  iconPosition?: 'left' | 'right'
  iconRotate?: number
  selected?: boolean
  layout?: 'thin' | 'normal'
  isDisabled?: boolean
}

export const DropdownItem: FunctionComponent<DropdownItemProps> = ({
  onClick,
  title,
  href,
  target,
  icon,
  iconPosition = 'left',
  iconRotate,
  children,
  selected,
  layout = 'normal',
  testId,
  isDisabled,
}) => {
  const colorPreset = useContext(DropDownColorPresetContext)

  const renderIcon = icon && (
    <div className={styles.icon}>
      <Icon icon={icon} rotate={iconRotate} size="nano" />
    </div>
  )

  return (
    <a
      onClick={onClick}
      title={title}
      href={href}
      target={target}
      rel={target === '_blank' ? 'noopener noreferrer' : undefined}
      className={classNamesCx({
        item: true,
        [layout]: true,
        [colorPreset]: true,
        right: iconPosition === 'right',
        selected,
        disabled: isDisabled,
      })}
      role="button"
      data-test-id={testId}
    >
      {iconPosition === 'left' && renderIcon}
      {children}
      {iconPosition === 'right' && renderIcon}
    </a>
  )
}
